import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {OnboardingOption} from '../../onboarding-option';

import styles from '../../onboarding-body.module.css';

export function OnboardingBodyDirection() {
    return (
        <OnboardingBody title='Our leads come from:'>
            <div>
                <div className={styles['check-all']}>
                    <em>(check all that apply)</em>
                </div>
                <OnboardingOption
                    option='usesInboundSales'
                    label='Website visitors and online ads'
                />
                <OnboardingOption
                    option='usesOutboundSales'
                    label='Cold calling, prospecting, or purchased lists'
                />
                <OnboardingOption
                    option='usesExistingLeads'
                    label='Most of our leads are existing customers'
                />
                <OnboardingOption option='wantsMoreLeads' label='We’re trying to find more leads' />
            </div>
        </OnboardingBody>
    );
}
